import React from 'react'
import "./SpinnerLoading.css"
import CircularProgress from "@mui/material/CircularProgress";

const SpinnerLoading = () => {
  return (
    <CircularProgress className='spinner-loading' />
  )
}

export default SpinnerLoading